import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

export default enterCallback =>
  Extension.create({
    name: 'enter-handler',
    addProseMirrorPlugins() {
      return [
        new Plugin({
          key: new PluginKey('keyDownEventHandler'),
          props: {
            handleKeyDown(view, ev) {
              if (enterCallback) {
                enterCallback(ev, view);
                // Return true for Enter key to prevent default behavior
                if (ev.code === 'Enter' || ev.key === 'Enter') {
                  return true;
                }
              }
              return false;
            },
          },
        }),
      ];
    },
  });
